import Vue from 'vue';
import Vuex from 'vuex';
import { IModule1State } from '@/store/modules/module1';

Vue.use(Vuex);

export interface IRootState {
  module1: IModule1State
}

// Declare empty store first, dynamically register all modules later.
export default new Vuex.Store<IRootState>({});
